import toast from "components/partials/toast/toast";

import { deeplyTransformEmptyStringToUndefined } from "utilities";
import { getTouchpointPaths } from "utilities/app-routes";
import { formatTouchpointClassesForApi } from "components/modals/creative-modal/creative-modal-utils";

import { AddTouchpointFormData } from "components/modals/creative-modal/creative-modal-types";

import type {
  TouchpointVersionBaseDTO,
  CreateTouchpointFromTemplateItemRequestContentType,
  CreateTouchpointFromTemplateItemRequestPopulationType,
  CreateTouchpointFromTemplateItemRequest,
} from "generated/schemas";
import { getProgramTemplates } from "generated/api/program-templates";

type SubmitCreateTouchpointFromTemplateParams = {
  data: AddTouchpointFormData;
  touchpointTemplates: TouchpointVersionBaseDTO[];
  clientId: string;
  campaignId: string;
};

export const submitCreateTouchpointFromTemplate = async ({
  data,
  touchpointTemplates,
  clientId,
  campaignId,
}: SubmitCreateTouchpointFromTemplateParams): Promise<string | null> => {
  const template = touchpointTemplates.find((t) => t.touchpointId === data.touchpointTemplateId);
  if (!template) {
    toast.error({
      data: { title: "Template not found", message: "Please select a template again." },
    });
    return null;
  }

  const touchpointAttributes = deeplyTransformEmptyStringToUndefined({
    name: data.name,
    contentType: data.contentType,
  });

  const payload: CreateTouchpointFromTemplateItemRequest = {
    templateTouchpointVersionId: template.versionId,
    campaignId: campaignId,
    name: touchpointAttributes.name || "",
    copyCode: data.copyCode,
    fiscalYear: data.fiscalYear,
    folderId: data.folderId,
    insightsActivator: data.insightsActivator,
    populationType: data.populationType as CreateTouchpointFromTemplateItemRequestPopulationType,
    contentType:
      touchpointAttributes.contentType as CreateTouchpointFromTemplateItemRequestContentType,
    classes: formatTouchpointClassesForApi(data.classes),
  };

  const api = getProgramTemplates();
  const results = await api.touchpointsFromTemplates(
    { clientId: clientId },
    {
      items: [payload],
    },
  );
  const created = results[0];
  if (!created) throw new Error("No touchpoint created");
  const { touchpointPreviewPath } = getTouchpointPaths({
    clientId,
    campaignId,
    touchpointId: created.id,
  });
  return touchpointPreviewPath;
};
